module.exports = __webpack_public_path__ + "img/image23.558098bc.png";